export default __webpack_public_path__ + "static/media/logo-light.392ffa76.svg";